<div class="th-menulevel modal">
  <div class="ir-btn ir-btn--big th-btn-remove" (click)="selectMenu(1)">
    <span>{{ 'menus.delete-picture' | translate }}</span>
  </div>
  <div
    *ngIf="currentPerson?.isHost && isConnection"
    class="ir-btn ir-btn--big th-btn-menulevel"
    (click)="selectMenu(10)"
  >
    <span>{{ 'menus.edit-json' | translate }} </span>
  </div>
  <div *ngIf="isConnection && !isInOffline" class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(11)">
    <span>{{ 'menus.edit' | translate }} </span>
  </div>
</div>
